import { buildStoreDataUrl, API_CONFIG } from "@/shared/configs/apiConfig.js"
import getSample from '../raws/get.json'

export default {
  url(payload) {
    console.log('🚀 ~ url ~ payload:', payload)
    return buildStoreDataUrl({ service: 'lol', userId: 'lol' })
  },

  parse(raw = {}, payload = {}) {
    // Simulation des données depuis ton fichier local
    raw = getSample.achievementRanks

    if (raw?.statusCode !== 200)
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Failed to contact server',
        data: null,
        raw: null,
      }

    if (!Array.isArray(raw?.data))
      return {
        statusCode: 400,
        message: 'Unexpected data got from server. Expecting Array',
        data: null,
        raw,
      }

    // === Mapping des données ===
    let data = raw.data.map(el => ({
      id: el.id,
      name: el.name,
      description: el.description,
      requiredTrophies: el.requiredTrophies,
      badgeImage: el.badgeImage || null,
      privileges: (el.privileges || []).map(p => ({
        type: p.type || null,
        value: p.value || null,
        duration: {
          amount: p.duration?.amount || null,
          unit: p.duration?.unit || null,
        },
        maxApplications: p.maxApplications ?? null,
      })),
      totalPrivileges: el.privileges?.length || 0,
    }))

    // === Tri dynamique selon payload.sortKey et sortOrder ===
    const { sortKey, sortOrder } = payload || {}
    if (sortKey) {
      const order = sortOrder === 'desc' ? -1 : 1
      data = [...data].sort((a, b) => {
        const valA = a?.[sortKey]
        const valB = b?.[sortKey]

        // Gestion des strings et nombres
        if (typeof valA === 'string' && typeof valB === 'string') {
          return valA.localeCompare(valB) * order
        }
        if (typeof valA === 'number' && typeof valB === 'number') {
          return (valA - valB) * order
        }
        return 0
      })
    }

    // === Recherche textuelle locale ===
    const searchTerm = (payload?.search || '').toString().trim().toLowerCase()
    if (searchTerm) {
      data = data.filter(el => {
        return Object.values(el).some(val => 
          val && typeof val !== 'object' && String(val).toLowerCase().includes(searchTerm)
        )
      })
    }

    // === Pagination ===
    const { page = 0, limit = 10000 } = payload || {}
    const paginated = data.slice(page * limit, (page + 1) * limit)

    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        total: data.length,
        result: paginated,
      },
    }
  },
}
